/* eslint-disable */
import localforage from 'localforage';
import JSZip from 'jszip';
import { cleanDITA } from '../features/counter/dita-clean';

let checkCacheInterval;

export function fetch_and_store(e) {
  let ccmsversion = e?.data?.ccmsversion;
  if (!ccmsversion) {
    ccmsversion = localforage.getItem('ccmsversion');
  }
console.log('ccmsversion', process.env.REACT_APP_CCMS_VERSION);
  console.log(`fetching /${ccmsversion}`);

  if (checkCacheInterval) {
    clearInterval(checkCacheInterval);
  }

  checkCacheInterval = setInterval(async () => {
    try {
      const cache = await caches.open(process.env.REACT_APP_CACHE_NAME);
      const response = await cache.match(`/viewTopic/${ccmsversion}.zip?__WB_REVISION__=1`);

      if (response) {
        console.log('hydrating...');
        clearInterval(checkCacheInterval);
  
        try {
          const rawBuffer = await response.arrayBuffer();
          const originalZipBuffer = await decryptAES(rawBuffer, process.env.REACT_APP_OFFLINE_SECRET);
          
          self.postMessage({ buffer: originalZipBuffer });
  
          await storeZipContentsInIndexedDB(originalZipBuffer, e.data.idbKeys, ccmsversion);
        } catch (err) {
          console.error("Error processing buffer:", err);
        }
      }
    } catch (err) {
      console.error("Error accessing cache:", err);
    }
  }, 10000);
  
}

async function cleanOldDBs(currentVersion) {
  const versionsToClean = ['s1', 's2', 's3', 's4', 's5', 's6'];

  let existingDBs = null;
  if (indexedDB.databases) {
    try {
      const dbs = await indexedDB.databases();
      existingDBs = dbs.map(db => db.name);
    } catch (err) {
      console.warn('Could not retrieve database list:', err);
    }
  }

  for (const version of versionsToClean) {
    if (version === currentVersion) {
      console.log(`Skipping cleanup for current database: ${version}`);
      continue;
    }

    if (existingDBs && !existingDBs.includes(version)) {
      console.log(`Database ${version} does not exist; skipping cleanup.`);
      continue;
    }

    try {
      await new Promise((resolve, reject) => {
        const req = indexedDB.deleteDatabase(version);
        req.onsuccess = () => resolve();
        req.onerror = () => reject(req.error);
        req.onblocked = () => console.warn(`Deletion of ${version} blocked.`);
      });
      console.log(`Successfully deleted old database: ${version}`);
    } catch (err) {
      console.warn(`Failed to delete database ${version}; continuing:`, err);
    }
  }
}

self.addEventListener('message', (e) => {
  if (e.data.command === 'fetchAndStore') {
    fetch_and_store(e);
  }

  if (e.data.command === 'Import') {
    storeZipContentsInIndexedDB(
      e.data.buffer,
      e.data.idbKeys,
      e.data.ccmsversion
    );
  }

  if (e.data.command === 'Hydrated') {
    caches.open(process.env.REACT_APP_CACHE_NAME).then((cache) => {
      cache
        .delete(`/viewTopic/${e.data.ccmsversion}.zip?__WB_REVISION__=1`)
        .then((response) => {
          if (response) {
           console.log(`--/${e.data.ccmsversion}?__WB_REVISION__=1`); 
          } else {
           console.log(`??/${e.data.ccmsversion}?__WB_REVISION__=1`); 
          }
        });
    });
  }
});

function binaryStringToBlob(binaryString, mimeType) {
  const arrayBuffer = new ArrayBuffer(binaryString.length);
  const uint8Array = new Uint8Array(arrayBuffer);

  for (let i = 0; i < binaryString.length; i++) {
    uint8Array[i] = binaryString.charCodeAt(i);
  }
  const blob = new Blob([uint8Array], { type: mimeType });
  return blob;
}


async function decryptAES(encryptedBuffer, key) {
  if (!key) {
    throw new Error("A valid decryption key must be provided.");
  }
  
  const encoder = new TextEncoder();
  const keyBytes = encoder.encode(key);

  const cryptoKey = await crypto.subtle.importKey(
    'raw',
    keyBytes,
    { name: 'AES-CTR', length: 256 },
    false,
    ['decrypt']
  );

  const iv = new Uint8Array(encryptedBuffer.slice(0, 16));
  const ciphertext = new Uint8Array(encryptedBuffer.slice(16));

  try {
    const decryptedBuffer = await crypto.subtle.decrypt(
      {
        name: 'AES-CTR',
        counter: iv,
        length: 64  // Match Node.js CTR length
      },
      cryptoKey,
      ciphertext
    );
    return decryptedBuffer;
  } catch (error) {
    console.error('Decryption failed:', error);
    throw error;
  }
}


function getMimeType(fileName) {
  // List of file extensions to be treated as binary data
  const binaryExtensions = ['txt', 'dita', 'ditamap', 'xml', 'json'];
  const extension = fileName.split('.').pop().toLowerCase();

  return binaryExtensions.includes(extension) ? 'string' : 'base64'; // TODO: implement blob...
  // possible options: 'string', 'base64', 'binarystring', 'array', 'uint8array', 'arraybuffer', 'blob', 'nodebuffer'
}

function getFileType(extension) {
  // List of file extensions to be treated as binary data
  const binaryExtensions = {
    '.pdf': 'application/pdf',
    '.jpg': 'image/jpeg',
    '.png': 'image/png',
    '.jpeg': 'image/jpeg',
    '.svg': 'image/svg+xml',
  };
  return binaryExtensions[extension];
}

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
// The main function to store zip contents into IndexedDB
async function storeZipContentsInIndexedDB(
  zipArrayBuffer,
  idbKeys,
  ccmsversion
) {
  // Configure localforage with the correct database name BEFORE any operations
  // Create a dedicated instance for the ccmsversion database
  const ccmsversionDB = localforage.createInstance({
    name: ccmsversion
  });
  
  try {
    await cleanOldDBs(ccmsversion);
  } catch (cleanupErr) {
    console.warn(`cleanOldDBs failed, continuing with new DB:`, cleanupErr);
  }
  
  let fileCount = 0;
  try {
    const zip = await JSZip.loadAsync(zipArrayBuffer);
    const files = Object.keys(zip.files);

    const totalFiles = files.length;

    for (let i = 0; i < files.length; i++) {
      if (i % 1000 === 0 || i >= totalFiles - 1) {
        const progress = Math.round((i / totalFiles) * 100);
        self.postMessage({ type: 'progress', progress });
      }

      let relativePath = files[i];

      let dataUri = '';
      const zipContent = zip.files[relativePath];
      const mimeType = getMimeType(relativePath);
      
      if (!zipContent.dir) {
        relativePath = relativePath.split('/');
        if (relativePath.indexOf('quicklinks/') === -1) {
          relativePath.shift(); // remove parent folder
        }
        relativePath = relativePath.join('/');
        relativePath =
          relativePath.indexOf('/') === -1
            ? relativePath
            : relativePath.split('/').slice(-1)[0];
        if (!idbKeys.includes(relativePath)) {
          // to download only new files
          try {
            let fileContent = await zip.file(files[i]).async(mimeType);

            dataUri =
              mimeType === 'string'
                ? fileContent
                : `data:${getFileType(
                    '.' + relativePath.split('.').pop()
                  )};base64,${fileContent}`;
          } catch (error) {
            console.log(error, relativePath);
          }

          let cleanDita = dataUri;

          try {
            if (mimeType === 'string') {
              cleanDita = cleanDITA(cleanDita, relativePath).trim();
            }
            // Use the versionDB instance to store data in the correct database
            await ccmsversionDB.setItem(relativePath, cleanDita);
          } catch (err) {
            console.error(`Error storing file: ${relativePath}`, err);
          }
        } else {
          fileCount++;
        }
      }
    }
  } catch (error) {
    console.log('zipArrayBuffer', zipArrayBuffer, fileCount);
    console.error('Failed to process ZIP file:', error);
  }
}
